import { useEffect } from 'react';

const SITE_NAME = 'Trade Connector';

/**
 * Sets the browser tab title and updates OG meta tags for the current page.
 *
 * @param title - Page-specific title (e.g. "Jobs", "Login").
 *                Will be formatted as "Jobs | Trade Connector".
 *                Pass empty string to reset to just "Trade Connector".
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    // Update OG meta tags for sharing (helps with JS-capable crawlers and
    // in-app browsers like Slack, iMessage, LinkedIn etc.)
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', fullTitle);
  }, [title]);
}

export default usePageTitle;
